import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart3, CheckCircle, TrendingUp, Trophy } from 'lucide-react';

const CandidateStatistics = ({ candidateData }) => {
    const { t } = useTranslation();
    const stats = [
        {
            value: candidateData?.statistics?.total_interviews || 0,
            label: t('candidateDetails.totalInterviews'),
            icon: BarChart3,
            color: 'text-gray-700',
            bgColor: 'bg-gray-50',
            borderColor: 'border-gray-200'
        },
        {
            value: candidateData?.statistics?.completed_interviews || 0,
            label: t('candidateDetails.completed'),
            icon: CheckCircle,
            color: 'text-green-700',
            bgColor: 'bg-green-50',
            borderColor: 'border-green-200'
        },
        {
            value: candidateData?.statistics?.average_score 
                ? parseFloat(candidateData.statistics.average_score).toFixed(2) + '%' 
                : '0%',
            label: t('candidateDetails.averageScore'),
            icon: TrendingUp,
            color: 'text-yellow-700',
            bgColor: 'bg-yellow-50',
            borderColor: 'border-yellow-200'
        },
        {
            value: candidateData?.statistics?.best_score 
                ? parseFloat(candidateData.statistics.best_score).toFixed(2) + '%' 
                : '0%',
            label: t('candidateDetails.bestScore'),
            icon: Trophy,
            color: 'text-red-700',
            bgColor: 'bg-red-50',
            borderColor: 'border-red-200'
        }
    ];

    const data = candidateData;

    return (
        <div>
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                    <BarChart3 className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">{t('candidateDetails.interviewStatistics')}</h3>
            </div>
            
            <div className="grid grid-cols-2 gap-3 mb-4">
                {stats.map((stat, index) => {
                    const IconComponent = stat.icon;
                    const actualValue = index === 0 ? data.statistics?.total_interviews || 0 :
                                     index === 1 ? data.statistics?.completed_interviews || 0 :
                                     index === 2 ? (data.statistics?.average_score ? parseFloat(data.statistics.average_score).toFixed(1) + '%' : '0%') :
                                     (data.statistics?.best_score ? parseFloat(data.statistics.best_score).toFixed(1) + '%' : '0%');
                    
                    return (
                        <div 
                            key={index}
                            className="bg-gradient-to-br from-white to-gray-50/50 rounded-xl border border-gray-200/50 p-4 text-center hover:shadow-md hover:border-blue-200/50 transition-all duration-200 group"
                        >
                            <div className="flex justify-center mb-3">
                                <div className={`p-2 ${stat.bgColor} rounded-lg group-hover:scale-110 transition-transform duration-200`}>
                                    <IconComponent size={18} className={stat.color} />
                                </div>
                            </div>
                            
                            <div className="text-2xl font-bold text-gray-900 mb-1">
                                {actualValue}
                            </div>
                            
                            <div className="text-xs text-gray-600 font-medium leading-tight">
                                {stat.label}
                            </div>
                        </div>
                    );
                })}
            </div>
            
            {candidateData?.statistics?.last_interview_date && (
                <div className="text-center">
                    <span className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 text-sm font-medium rounded-xl border border-blue-200/50">
                        {t('candidateDetails.lastInterview')} {new Date(candidateData.statistics.last_interview_date).toLocaleDateString()}
                    </span>
                </div>
            )}
        </div>
    );
};

export default CandidateStatistics;